import PropTypes from 'prop-types';
// material
import { Paper, Typography } from '@material-ui/core';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Paper {...other} sx={{ padding: 2 }}>
      <Typography gutterBottom align="center" variant="subtitle1">
      {searchQuery != '' ? 'Not found' : 'No tickets found'}
      </Typography>
      {searchQuery != '' && (
      <Typography variant="body2" align="center" sx={{ marginTop: 1 }}>
        No results found for &nbsp;
          <strong>&quot;{searchQuery}&quot;</strong>. Try checking for typos or using complete words.
        </Typography>
      )}
    </Paper>
  );
}
